import { Layout, Row, Col, Spin, Empty, Menu, InputNumber, DatePickerProps } from "antd";
import { useEffect, useState } from "react";
import { DatePicker, Space } from "antd";
import dayjs from "dayjs";
import { Card, Button, Tag } from "antd";
import { TAssetGroup } from "@components/types";
import { getCheckInTimeFormat, getCheckOutTimeFormat, humanizeCurrency } from "@core/utils";
import { checkAssetGroupAvailability, getAssetGroups } from "@api/asset";
import moment from "moment";
import type { RangePickerProps } from "antd/es/date-picker";

const { RangePicker } = DatePicker;

const { Content } = Layout;

const { Header } = Layout;

const RoomCard = ({ room, available, startDate, endDate }: { room: TAssetGroup, available: any, startDate: string, endDate: string }) => {
    const [roomCount, setRoomCount] = useState<number>(1);

    return (
        <Card
            hoverable
            cover={
                <img
                    alt={room.name}
                    src={room.details[0]?.url || "https://jhattse.com/public/consumer/placeholder/product_square.png"}
                    height={200}
                    style={{ objectFit: "cover" }}
                />
            }
            onClick={() => {
                window.location.href = `/demo/detail?asset_group_id=${room.id}&start_date=${startDate}&end_date=${endDate}&store_id=568&room_count=${roomCount}`;
            }}
        >
            <h3>{room.name}</h3>
            {/* <Tag>{room.capacity} Guests</Tag> */}

            <p style={{ fontSize: 18, fontWeight: 600, marginTop: 8 }}>
                {humanizeCurrency(room?.prices[0]?.price || room?.price)} / night
            </p>

            <Space direction="vertical" style={{ width: "100%" }}>
                <InputNumber
                    min={0}
                    max={available?.available}
                    value={roomCount}
                    onChange={(v) => setRoomCount(v)}
                    addonBefore="Rooms"
                    style={{ width: "100%" }}
                />

                <Button
                    type="primary"
                    block
                    href={`/stays/568?start_date=${startDate}&end_date=${endDate}&asset_group_id=${room.id}&plan_id=${room?.prices[0]?.id}&room_count=${roomCount}`}
                >
                    Book Now
                </Button>
            </Space>
        </Card>
    )
}

export default function HomePage() {
    const [loading, setLoading] = useState(false);
    const [rooms, setRooms] = useState<TAssetGroup[]>([]);
    const [searched, setSearched] = useState(false);
    const [dates, setDates] = useState<any>([moment().startOf("day").format(`YYYY-MM-DDTHH:mm:ss`), moment().add(1, "day").endOf("day").format(`YYYY-MM-DDTHH:mm:ss`)]);
    const [guests, setGuests] = useState<any>(2);
    const [available, setAvailable] = useState<any>([]);





    const checkAvailability = async () => {
        setLoading(true);
        setSearched(true);

        try {
            checkAssetGroupAvailability(568, [], [], moment(dates[0])?.format(`YYYY-MM-DDTHH:mm:ss`), moment(dates[1])?.format(`YYYY-MM-DDTHH:mm:ss`))?.then((res) => {
                setAvailable(res)
            })
        } catch (e) {
            setRooms([]);
        } finally {
            setLoading(false);
        }
    };

    const getAllAssetGroup = async () => {
        await getAssetGroups(568)?.then((res) => {
            setRooms(res);
        });
    };

    useEffect(() => {
        getAllAssetGroup();
        checkAvailability();
    }, []);

    const onChange = (
        value: DatePickerProps['value'] | RangePickerProps['value'],
        dateString: [string, string] | string,
    ) => {
        if (Array.isArray(dateString)) {
            setDates([moment(dateString[0]).format(`YYYY-MM-DD`), moment(dateString[1]).format(`YYYY-MM-DD`)]);
        }
    };

    return (
        <Layout>
            <Header
                style={{
                    background: "#fff",
                    borderBottom: "1px solid #eee",
                    position: "sticky",
                    top: 0,
                    zIndex: 100,
                }}
            >
                <div
                    style={{
                        maxWidth: 1200,
                        margin: "0 auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <h2 style={{ margin: 0 }}>🏨 HotelBook</h2>

                    <Menu mode="horizontal" items={[
                        { key: "home", label: "Home" },
                        { key: "rooms", label: "Rooms" },
                        { key: "contact", label: "Contact" },
                    ]} />
                </div>
            </Header>

            <div style={{ background: "#fafafa", padding: 24 }}>
                <Space size="middle" wrap style={{ display: "flex", justifyContent: "center" }}>

                    <RangePicker
                        value={[dayjs(dates[0]), dayjs(dates[1])]}
                        onChange={onChange}
                        format="ddd, DD MMM, YYYY"
                        disabledDate={(current) => {
                            return current && current < dayjs().startOf('day');
                        }}
                        allowClear={false}
                    />

                    <InputNumber
                        min={1}
                        max={10}
                        value={guests}
                        onChange={(v) => setGuests(v || 1)}
                        addonBefore="Guests"
                    />

                    <Button
                        type="primary"
                        size="large"
                        loading={loading}
                        disabled={!dates}
                        onClick={() =>
                            checkAvailability(                            )
                        }
                    >
                        Check Availability
                    </Button>
                </Space>
            </div>

            <Content style={{ padding: 24, maxWidth: 1200, margin: "auto" }}>
                {loading && (
                    <div style={{ textAlign: "center", marginTop: 50 }}>
                        <Spin size="large" />
                    </div>
                )}

                {!loading && searched && rooms.length === 0 && (
                    <Empty description="No rooms available" />
                )}

                {(!loading && searched && rooms.length > 0) &&
                    <Row gutter={[24, 24]}>
                        {rooms.map((room) => (
                            <Col xs={24} md={12} lg={8} key={room.id}>
                                <RoomCard room={room} available={available?.find((a: any) => a?.id === room?.id)} startDate={dates[0]} endDate={dates[1]} />
                            </Col>
                        ))}
                    </Row>
                }
            </Content>
        </Layout>
    );
}
